import { Element, Option } from "@p0security/shared/install/types";

export const DatabaseHosting = Element({
  label: "Hosting",
  description: "How this instance is hosted",
  type: "select",
  step: "new",
  default: "aws-rds",
  options: {
    "aws-rds": Option({
      maturity: "ga" as const,
      label: "AWS RDS",
      schema: {
        connectorArn: Element({
          label: "AWS Lambda ARN",
          description: "",
          type: "generated",
        }),
        instanceArn: Element({
          label: "AWS RDS ARN",
          description: "The ARN of this RDS instance",
          type: "string",
          step: "new",
        }),
        resourceId: Element({
          label: "AWS RDS resource ID",
          description: "The resource ID of the instance or cluster",
          type: "generated",
        }),
        vpcId: Element({
          label: "AWS RDS VPC ID",
          description: "The AWS RDS VPC installation that hosts this database",
          type: "dynamic",
          step: "new",
        }),
      },
    }),
    "gcp-cloudsql": Option({
      label: "GCP CloudSQL",
      maturity: "preview",
      schema: {
        vpcId: Element({
          label: "GCP VPC ID",
          description:
            "The GCP CloudSQL VPC installation that hosts this database",
          type: "dynamic",
          step: "new",
        }),
        projectId: Element({
          label: "Project ID",
          description: "The GCP Project in which this instance is provisioned",
          type: "generated",
        }),
        instanceName: Element({
          label: "CloudSQL instance name",
          description: "The name of the instance",
          type: "string",
          step: "new",
        }),
        connectorServiceAccount: Element({
          label: "GCP Cloud Run service account",
          description:
            "The service account that the Cloud Run connector is running as",
          type: "generated",
        }),
        connectorServiceName: Element({
          label: "GCP Cloud Run service name",
          description: "",
          type: "generated",
        }),
        connectorServiceUri: Element({
          label: "GCP Cloud Run service URI",
          description:
            "The invocation URL of the connector's Cloud Run service, resolved once at install time.",
          type: "generated",
        }),
        connectorRegion: Element({
          label: "Region",
          description: "The GCP region in which the connector is provisioned.",
          type: "hidden",
        }),
      },
    }),
  },
});
